<template>
  <section class="pt-90 pb-60 overflow-hidden " data-aos="fade-up" :data-aos-delay="200">
    <div class="row y-gap-20 justify-between items-center">
      <div class="col-lg-6">
        <div class="sectionTitle">
          <h2 class="sectionTitle__title">{{ $t("top_rated_courses") }}</h2>
          <p class="sectionTitle__text">
            {{ $t("join_thousands_of_learners") }}
          </p>
        </div>
      </div>

      <div class="col-auto mb-3">
        <router-link to = "/courses" class="button -icon">
          {{ $t("view_all") }}
        </router-link>
      </div>
    </div>

    <div class="row pt-40">
      <div class="col-lg-4 col-md-6 d-flex flex-column mb-15" v-for="course in featured" :key="course.uuid">
        <coursecard :showLevel="true" :showPrice="false" :item="course" />
      </div>
    </div>

  </section>
</template>

<script>
import AOS from "aos";
import Coursecard from "../common/Coursecard.vue";
import { FeaturedCourses } from "@/Services/api/CoursesService";
import { mapGetters } from "vuex";
export default {
  components: {
    Coursecard,
  },
  data() {
    return {
      featured: null
    };
  },
  computed: {
    ...mapGetters(['currentLanguage']),
  },
  methods: {
    async getFeaturedData() {
      try{
        let response = await FeaturedCourses();
        this.featured = response.data;
      }catch(error){
        console.log(error)
      }
    }
  },
  watch: {
    currentLanguage: {
      handler(newLang, oldLang) {
        this.getFeaturedData();
      },
      immediate: true, // Run the handler immediately when the component is mounted
    },
  },
  mounted() {
    AOS.init({
      duration: 1000, // Animation duration
      once: true, // Whether animation should happen only once
    });
  },
};
</script>
<style lang="scss" scoped>
@media screen and (max-width: 560px){
  .pt-90{
    padding-top: 40px !important; 
  }
}
</style>